import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import { DEFAULT_MIN_YEAR } from "static/constants";
import { getCurrentYearAndMonth } from "utils/date";
import { useSelector, useDispatch } from "react-redux";
import { setFilter } from "app/store/nonCompliantPatient/slice/nonCompliantPatientSlice";

const YearlyFilter = () => {
  const { currentYear, currentMonth } = getCurrentYearAndMonth();
  const numOfYear =
    currentMonth === 1
      ? currentYear - DEFAULT_MIN_YEAR
      : currentYear - DEFAULT_MIN_YEAR + 1;

  const { year } = useSelector((state) => state.nonCompliantPatient);
  const dispatch = useDispatch();

  return (
    <>
      <FormControl fullWidth>
        <InputLabel id="year-select-label">Year</InputLabel>

        <Select
          labelId="year-select-label"
          id="year-select-helper"
          value={year}
          label="Year"
          onChange={(e) => {
            dispatch(
              setFilter({
                type: "year",
                value: e.target.value,
              })
            );
            dispatch(
              setFilter({
                type: "month",
                value: 1,
              })
            );
          }}
        >
          {Array.from(new Array(numOfYear), (_value, index) => {
            const label =
              currentMonth === 0
                ? currentYear - 1 - index
                : currentYear - index;

            return (
              <MenuItem key={index} value={label}>
                {label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </>
  );
};

export default YearlyFilter;
